// extracted by mini-css-extract-plugin
export default {"decorate":"MKfa","topBorder":"YbE0","mr":"druX","ml":"PqjF","view":"FI8Z","l":"KJGW","langToggle":"KOTi","sep":"UD1s","active":"t_FN"};